import styled from 'styled-components';
import * as mixins from '../../../common/styles/mixins';

export const BrokerLandingSustainabilityHubWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  .brokerLandingPageSustainabilityHubMobile {
    ${mixins.widgetMobile};
  }

  .brokerLandingPageSustainabilityHub {
    ${mixins.widgetDesktop};
  }

  .container {
    width: 100%;
    margin: 0px;
    padding-left: 0px;
  }

  .left {
    float: left;
    padding-right: 10px;
    width: 40%;
  }

  .right {
    float: right;
    width: 60%;
  }
`;
